import { createSlice } from '@reduxjs/toolkit';
import { leggiErroreLuogoEvento } from '../../../components/detailTask/claimData/luogoEvento/luogoEvento.mapper';

/**
 * CSP-2788 (T9, R32) - ultimo rifiuto del salvataggio della denuncia per luogo evento incompleto,
 * per task: lo scrive il salvataggio (DetailTask), lo legge il form del luogo (ClaimData) per
 * mostrarlo accanto ai campi invece che solo nel toast. Per task perche' i tab aperti sono piu' d'uno.
 */
const initialState = {
  erroriSalvataggio: {},
};

export const LuogoEventoSlice = createSlice({
  name: 'luogoEvento',
  initialState,
  reducers: {
    /** payload {taskId, errore}: errore {messaggio, campi} oppure null per toglierlo. */
    setErroreSalvataggioLuogoEvento: (state, action) => {
      const { taskId, errore } = action.payload || {};
      if (!taskId) return;
      if (errore) {
        state.erroriSalvataggio[taskId] = errore;
      } else {
        delete state.erroriSalvataggio[taskId];
      }
    },
  },
});

export const { setErroreSalvataggioLuogoEvento } = LuogoEventoSlice.actions;

/**
 * Esito del PUT della denuncia per il luogo evento: un 422 sul luogo incompleto resta accanto ai
 * campi, qualunque altro esito (successo o errore diverso) toglie il messaggio precedente.
 * @param {string} taskId task del salvataggio
 * @param {object} errore errore axios, oppure null se il salvataggio e' andato a buon fine
 * @returns {{messaggio: string, campi: string[]} | null} l'errore del luogo, se e' quello
 */
export const registraEsitoSalvataggioLuogoEvento = (taskId, errore) => (dispatch) => {
  const erroreLuogo = errore ? leggiErroreLuogoEvento(errore) : null;
  dispatch(setErroreSalvataggioLuogoEvento({ taskId, errore: erroreLuogo }));
  return erroreLuogo;
};

export default LuogoEventoSlice.reducer;
